import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { RTL } from "components";

import {
  AccountBalanceOutlined,
  BusinessOutlined,
  CreditCardOutlined,
  LocationOnOutlined,
  PersonOutline,
  PhoneOutlined,
  VerifiedUserOutlined,
} from "@material-ui/icons";

import { Controller, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";

import axios from "axios";

import FormSection from "./components/FormSection";

import ImageUploader from "./components/ImageUploader";

import { Autocomplete } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import { BaseUrl, NewBaseUrl } from "axios/api";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "redux/Action";
import VerificationStatus from "./components/VerficationStatus";
import { validateNationalCode } from "./validators";

const useStyles = makeStyles({
  checkbox: {
    color: "#e53935",
  },
  buttonProgress: {
    color: "#121E3E",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: -12,
  },
});

const schema = yup.object({
  firstName: yup.string().required("نام الزامی است"),

  lastName: yup.string().required("نام خانوادگی الزامی است"),

  nationalCode: yup
    .string()
    .test("national", "کد ملی صحیح نیست", validateNationalCode)
    .required(),

  provinceCity: yup.object().required("شهر الزامی است"),
  type: yup.object().required("شغل الزامی است"),

  carrierName: yup.string().nullable(),
  // .when("type", {
  //   is: (value) => value?.name !== "صاحب بار و کالا",
  //   then: (schema) => schema.required("نام دفتر الزامی است"),
  //   otherwise: (schema) => schema,
  // }),

  companyNationalId: yup.string().nullable(),
  // .when("type", {
  //   is: (value) => value?.name !== "صاحب بار و کالا",
  //   then: (schema) => schema.required("شناسه ملی الزامی است"),
  //   otherwise: (schema) => schema,
  // }),

  officePhone: yup.string().required("تلفن ثابت الزامی است"),

  officeAddress: yup.string().required("آدرس الزامی است"),

  agreement: yup
    .boolean()
    .oneOf([true], "برای ادامه باید صحت اطلاعات را تأیید کنید."),
});

export default function Auth() {
  const {
    control,
    getValues,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      firstName: "",
      lastName: "",
      nationalCode: "",
      provinceCity: null,
      type: null,
      postalCode: "",
      carrierName: "",
      companyNationalId: "",
      officePhone: "",
      officeAddress: "",
      agreement: false,
    },
  });
  const dispatch = useDispatch();

  const [nationalCard, setNationalCard] = useState(null);
  const [Roles, setRoles] = React.useState([]);
  const [selfie, setSelfie] = useState(null);
  const [Allcities, setAllcities] = useState([]);
  const token = useSelector((state) => state.token);
  const classes = useStyles();
  const current_user = useSelector((state) => state.userCurrent);
  const [isVerified, setIsVerified] = useState(0);
  const [userAuthDetail, setUserAuthDetail] = useState();
  const [loading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);

  const getDataReg = async (headers) => {
    try {
      const resRole = await axios.get("users/types", {
        baseURL: NewBaseUrl,
        headers: headers,
      });
      setRoles(resRole.data.filter((item) => item.name !== "راننده"));

      const resCity = await axios.get("cities", {
        baseURL: BaseUrl,
        headers: headers,
      });
      let dataCity = resCity.data.cities;
      let final_City = [];
      dataCity.forEach((obj, i) => {
        final_City = [
          ...final_City,
          {
            id: obj.id,
            province_id: obj.province_id,
            county_id: obj.county_id,
            name: obj.name + " " + obj.get_province?.name,
          },
        ];
      });
      setAllcities(final_City);
    } catch (e) {}
  };

  const getRequestDetail = async (headers, request) => {
    setLoading(true);
    try {
      const res = await axios.get(`users/${request.id}`, {
        baseURL: NewBaseUrl,
        headers: headers,
      });

      setIsVerified(res.data.is_verified);

      if (res.data.is_verified !== 0 && res.data.info) {
        setValue("firstName", res.data.info.firstname);
        setValue("lastName", res.data.info.lastname);
        setValue("nationalCode", res.data.info.ssn);
        setValue("provinceCity", res.data.info.city);
        setValue("type", res.data.info.get_type);
        setValue("carrierName", res.data.info.name);
        setValue("companyNationalId", res.data.info.nid);
        setValue("officePhone", res.data.info.tel);
        setValue("officeAddress", res.data.info.address);
        setNationalCard({
          file: "https://api.onlinebar.app/uploads/" + res.data.files[0].url,
          preview: "https://api.onlinebar.app/uploads/" + res.data.files[0].url,
        });
        setSelfie({
          file: "https://api.onlinebar.app/uploads/" + res.data.files[1].url,
          preview: "https://api.onlinebar.app/uploads/" + res.data.files[1].url,
        });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (current_user.id) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-client-version": "8",
      };
      getRequestDetail(headers, current_user);
    }
  }, [current_user.id]);

  const getUserAuthDetail = async (headers) => {
    try {
      const resUserDetail = await axios.get(`users/${current_user.id}`, {
        baseURL: NewBaseUrl,
        headers: headers,
      });
      console.log({ resUserDetail });
      setUserAuthDetail(resUserDetail.data);
    } catch (e) {}
  };

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-client-version": "8",
    };
    getDataReg(headers);
    getUserAuthDetail(headers);
  }, [token]);

  const submit = async (data) => {
    if (!nationalCard || !selfie) {
      dispatch(showSnackbar(true, "error", "مدارک هویتی الزامی است"));
      return;
    }
    if (data.type.name !== "صاحب بار و کالا") {
      if (!data.companyNationalId || !data.carrierName) {
        dispatch(
          showSnackbar(true, "error", "نام دفتر و شناسه ملی الزامی است")
        );
        return;
      }
    }
    setSendLoading(true);
    const formData = new FormData();

    formData.append("type", data.type.id);
    formData.append("firstname", data.firstName);
    formData.append("lastname", data.lastName);
    formData.append("ssn", data.nationalCode);
    formData.append("nid", data.companyNationalId);
    formData.append("name", data.carrierName);
    formData.append("tel", data.officePhone);
    formData.append("city-id", data.provinceCity.id);
    formData.append("address", data.officeAddress);

    formData.append("file1", nationalCard.file);

    formData.append("file2", selfie.file);
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-client-version": "8",
    };
    axios
      .post(`users/info`, formData, {
        baseURL: NewBaseUrl,
        headers: headers,
      })
      .then((res) => {
        dispatch(showSnackbar(true, "success", "اطلاعات با موفقیت ثبت شد"));
        if (current_user.id) {
          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-client-version": "8",
          };
          getRequestDetail(headers, current_user);
          // setSendLoading(false);
        }
        setSendLoading(false);
      });
  };

  const field = (name, label, icon, props = {}) => (
    <Controller
      name={name}
      control={control}
      disabled={isVerified === 2 || sendLoading}
      render={({ field }) => (
        <TextField
          {...field}
          {...props}
          fullWidth
          variant="outlined"
          label={label}
          error={!!errors[name]}
          helperText={errors[name]?.message}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">{icon}</InputAdornment>
            ),

            style: {
              borderRadius: 4,
              textAlign: "right",
              background: "#fff",
            },
          }}
        />
      )}
    />
  );
  const AutoCompleteField = ({
    noOptionsText,
    options,
    onChange,
    label,
    name,
  }) => (
    <Controller
      name={name}
      control={control}
      disabled={isVerified === 2 || sendLoading}
      render={({ field, fieldState }) => (
        <Autocomplete
          {...field}
          noOptionsText={noOptionsText}
          options={options}
          style={{ width: "100%" }}
          getOptionLabel={(option) => option.name || ""}
          onChange={(_, value) => {
            console.log({ value });
            field.onChange(value);

            if (onChange) {
              onChange(value);
            }
          }}
          renderInput={(params) => (
            <TextField
              // className={classes.input}
              {...params}
              label={label}
              variant="outlined"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              disabled={isVerified === 2}
            />
          )}
        />
      )}
    />
  );
  if (loading)
    return <CircularProgress size={24} className={classes.buttonProgress} />;
  return (
    <RTL>
      <form onSubmit={handleSubmit(submit)}>
        <Box bgcolor="#F5F7FB" minHeight="100vh" py={5}>
          <Box maxWidth={1100} mx="auto">
            {/* HEADER */}
            {isVerified === 0 ? (
              <Card
                elevation={0}
                style={{
                  borderRadius: 18,

                  marginBottom: 25,

                  border: "1px solid #EEF2F7",
                }}
              >
                <CardContent>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Box
                        width={70}
                        height={70}
                        borderRadius="50%"
                        bgcolor="#EDF4FF"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <VerifiedUserOutlined
                          style={{
                            color: "#2979ff",

                            fontSize: 40,
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item>
                      <Typography
                        variant="h5"
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        {/* ثبت احراز هویت */}
                        اعتماد، اولین قدم یک همکاری مطمئن است.
                      </Typography>

                      <Typography
                        style={{
                          color: "#7A869A",

                          marginTop: 6,
                        }}
                      >
                        با تکمیل احراز هویت، اعتبار حساب کاربری خود را افزایش
                        دهید تا رانندگان با اطمینان بیشتری درخواست‌های شما را
                        بپذیرند و فرآیند ثبت بار با اعتماد بیشتری انجام شود.
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ) : (
              <VerificationStatus status={isVerified} rejectReason={""} />
            )}

            {/* اطلاعات شخصی */}
            <FormSection
              title="اطلاعات شخصی"
              color="#2979ff"
              icon={<PersonOutline />}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  {field("firstName", "نام", <PersonOutline color="action" />)}
                </Grid>

                <Grid item xs={12} md={6}>
                  {field(
                    "lastName",
                    "نام خانوادگی",
                    <PersonOutline color="action" />
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  {field(
                    "nationalCode",
                    "کد ملی",
                    <CreditCardOutlined color="action" />
                  )}
                </Grid>
              </Grid>
            </FormSection>

            {/* اطلاعات شرکت */}

            <FormSection
              title="اطلاعات شرکت و دفتر"
              color="#8B5CF6"
              icon={<BusinessOutlined />}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <AutoCompleteField
                    name={"type"}
                    options={Roles}
                    noOptionsText="همچنین شغلی وجود ندارد"
                    label="عنوان شغل"
                    onChange={(v) => {
                      setValue("type", v);
                    }}
                  />
                </Grid>
                {watch("type")?.name != "صاحب بار و کالا" && (
                  <>
                    <Grid item xs={12} md={6}>
                      {field(
                        "carrierName",
                        `نام ${watch("type")?.name || "شرکت"}`,
                        <BusinessOutlined color="action" />
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      {field(
                        "companyNationalId",
                        "شناسه ملی",
                        <AccountBalanceOutlined color="action" />
                      )}
                    </Grid>
                  </>
                )}
                <Grid item xs={12} md={6}>
                  {field(
                    "officePhone",
                    "تلفن ثابت",
                    <PhoneOutlined color="action" />
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <AutoCompleteField
                    name={"provinceCity"}
                    options={Allcities}
                    noOptionsText="همچنین شهری وجود ندارد"
                    onChange={(v) => {
                      setValue("provinceCity", v);
                    }}
                    label="شهر"
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  {field(
                    "officeAddress",
                    "آدرس دفتر",
                    <LocationOnOutlined color="action" />
                  )}
                </Grid>
              </Grid>
            </FormSection>

            {/* مدارک هویتی */}
            <FormSection
              title="مدارک هویتی"
              color="#FFB020"
              icon={<CreditCardOutlined />}
            >
              {/* Info Box */}
              <Box
                mb={3}
                p={2}
                style={{
                  background: "#FFF8E6",
                  borderRadius: 12,
                  border: "1px solid #FFE0A3",
                  color: "#8A5A00",
                  fontSize: 13,
                  lineHeight: 1.8,
                }}
              >
                لطفاً تصاویر واضح و بدون برش از مدارک ارسال کنید. حجم هر فایل
                حداکثر 5MB باشد.
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <ImageUploader
                    title="تصویر کارت ملی (رو)"
                    value={nationalCard}
                    onChange={setNationalCard}
                    removeDisable={isVerified === 2 || sendLoading}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <ImageUploader
                    title="سلفی با کارت ملی"
                    value={selfie}
                    onChange={setSelfie}
                    removeDisable={isVerified === 2 || sendLoading}
                  />
                </Grid>
              </Grid>
            </FormSection>

            {/* تایید نهایی */}
            <FormSection
              title="تایید و ارسال"
              color="#22C55E"
              icon={<VerifiedUserOutlined />}
            >
              <Box
                p={2}
                mb={2}
                style={{
                  background: "#F0FDF4",
                  borderRadius: 12,
                  border: "1px solid #BBF7D0",
                }}
              >
                <Typography
                  style={{
                    fontSize: 13,
                    color: "#166534",
                    lineHeight: 1.8,
                  }}
                >
                  با ثبت این فرم، شما تایید می‌کنید که اطلاعات وارد شده صحیح
                  بوده و مسئولیت هرگونه مغایرت بر عهده شماست.
                </Typography>
              </Box>

              <Controller
                name="agreement"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={field.value || false}
                          onChange={(e) => field.onChange(e.target.checked)}
                          color="primary"
                          className={fieldState.error ? classes.checkbox : {}}
                        />
                      }
                      label="صحت اطلاعات و مدارک ارسالی را تأیید می‌کنم."
                    />

                    {fieldState.error && (
                      <Typography
                        style={{
                          color: "#d32f2f",
                          fontSize: 12,
                          marginTop: -5,
                          marginRight: 32,
                        }}
                      >
                        {fieldState.error.message}
                      </Typography>
                    )}
                  </>
                )}
              />
            </FormSection>

            {/* Submit Button */}
            <Box mt={3} mb={6} display="flex" justifyContent="center">
              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={isVerified === 2 || sendLoading}
                fullWidth
                style={{
                  maxWidth: 420,
                  background:
                    "linear-gradient(135deg, #22C55E 0%, #16A34A 100%)",
                  color: "#fff",
                  fontWeight: 700,
                  padding: "14px 0",
                  borderRadius: 14,
                  boxShadow: "0 10px 20px rgba(34,197,94,0.25)",
                  textTransform: "none",
                  fontSize: 16,
                  minHeight: 56,
                }}
              >
                {sendLoading ? (
                  <CircularProgress
                    size={24}
                    // className={classes.buttonProgress}
                    style={{ color: "#fff" }}
                  />
                ) : (
                  "ثبت احراز هویت"
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </form>
    </RTL>
  );
}
